import { type UseQueryResult, useQuery } from 'react-query';
import {
  // eslint-disable-next-line camelcase
  type Wealthlane_AwardService_Dtos_Dashboard_ParticipantTaskResponseDto,
} from '../../services/wealthlane-award-services';
import { ParticipantTaskService } from '../../services/wealthlane-award-services/services/ParticipantTaskService';

const useGetParticipantDashboardTaskSummery = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
  //   isOnBoarded?: boolean
): UseQueryResult<
  // eslint-disable-next-line camelcase
  Wealthlane_AwardService_Dtos_Dashboard_ParticipantTaskResponseDto | undefined,
  unknown
> => {
  const participantDashboardTaskSummery = useQuery(
    ['getParticipantDashboardTaskSummery'],
    async () => {
      //   if (isOnBoarded) {
      return await handleRequest(
        ParticipantTaskService.getApiAwardApiAppDashboardParticipantTaskSummary()
      );
    }
    // }
  );
  return participantDashboardTaskSummery;
};

export default useGetParticipantDashboardTaskSummery;
